import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ClientService } from 'src/app/services/client.service';
import { ContextService } from 'src/app/services/context.service';

@Component({
	selector: 'app-welcome-configure',
	templateUrl: './welcome-configure.component.html',
	styleUrls: ['./welcome-configure.component.css']
})
export class WelcomeConfigureComponent implements OnInit {
	@ViewChild('inputId') inputId: ElementRef;
	@ViewChild('inputSecret') inputSecret: ElementRef;

	loading = false;

	step: number = 1;			// 1-2
	existingAdobeSign;

	formAPIKeys: UntypedFormGroup;

	idValid: boolean;
	secretValid: boolean;

	constructor(
		private fb: UntypedFormBuilder,
		private clientService: ClientService,
		private contextService: ContextService,
		private router: Router
	) { }

	ngOnInit() {
		this.initFormAPIKeys();
	}


	initFormAPIKeys() {
		this.formAPIKeys = this.fb.group({
			id: new UntypedFormControl('', [Validators.required]),
			secret: new UntypedFormControl('', [Validators.required]),
		});

		this.idValid = null;
		this.secretValid = null;
	}

	doIdValidation(e: any) {
		if (e.target.value) {
			this.idValid = true;
		} else {
			this.idValid = false;
		}
	}

	doSecretValidation(e: any) {
		if (e.target.value) {
			this.secretValid = true;
		} else {
			this.secretValid = false;
		}
	}

	updateAPIKeys() {
		this.loading = true;
		let clientDetailProcore =
		{
			'clientId': this.contextService.clientDetailProcore.clientId,
			'companyId': this.contextService.procoreContextObject.context.company_id,
			'adobeApplicationId': this.inputId.nativeElement.value,
			'adobeClientSecret': this.inputSecret.nativeElement.value,
			'adobeAccountType': 'OAUTH'
		};

		this.clientService.updateClientDetailProcore(clientDetailProcore)
			.subscribe((clientDetailProcore) => {
				console.log(clientDetailProcore);

				this.router.navigate(['/welcome/authenticate']);
			});
	}

	selectBack() {
		this.step = this.step - 1;
	}

	selectExistingAdobeSign() {
		this.step = 2;
		this.existingAdobeSign = true;
	}

	selectNewAdobeSign() {
		this.step = 2;
		this.existingAdobeSign = false;

		// TODO: Create an adobe team

		// TODO: Create an adobe user

		// TODO: Add the adobe user to the team

		// TODO: Create an 

	}
}
